export default __webpack_public_path__ + "static/media/avatar_02.1ab3664f.png";